<template>
  <button class="choice" :class="{ '-selected': selectedValue === value }" @click="select">
    <span class="choice__radio"></span>
    <span class="choice__content">
      <span class="choice__title">{{ title }}</span>
      <span class="choise__subtitle">{{ subTitle }}</span>
    </span>
  </button>
</template>

<script>
export default {
  name: "ButtonRadioTypeComponent",
  emits: ["selected"],
  props: {
    value: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
    selectedValue: {
      type: String,
      required: true,
    },
  },
  methods: {
    select() {
      this.$emit("selected", this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.choice {
  display: flex;
  background: $bg-grey;
  border: 1px solid $grey;
  border-radius: $radius;
  color: $black;
  text-align: left;
  padding: 15px;
  align-items: center;
  margin-bottom: 20px;

  @include dark-theme {
    border-color: $m-color_12;
    background: $m-color_12;
    color: $white;
  }

  &__title {
    font-weight: 700;
    font-size: 15px;
    margin-bottom: 5px;
  }

  &__content {
    display: flex;
    flex-direction: column;
  }

  &__radio {
    border: 1px solid $dark-grey;
    width: 15px;
    min-width: 15px;
    height: 15px;
    min-height: 15px;
    background: $white;
    border-radius: 50%;
    margin-right: 10px;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      top: 2px;
      left: 2px;
      width: 9px;
      height: 9px;
      background: $blue;
      border-radius: 50%;
      display: none;
    }
  }

  &.-selected {
    border-color: $blue;
    background: $light-blue;

    @include dark-theme {
      border-color: $white;
      background: $m-color_12;
    }

    .choice__radio {
      &:after {
        display: block;
      }
    }
  }
}
</style>
